import { SMS_SUBSCRIPTION, WHATSAPP_SUBSCRIPTION } from '../../../filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { COMMUNICATION_SUBSCRIPTION } from '../ObjectSegFilterTypes';
export const SUBSCRIPTION_TYPE = 'INDIVIDUAL_SUBSCRIPTION';
export const SMS_CHANNEL = 'SMS';
export const WHATSAPP_CHANNEL = 'WHATSAPP';
const CommunicationFilterFamilyToChannelMap = Object.freeze({
  [SMS_SUBSCRIPTION]: SMS_CHANNEL,
  [WHATSAPP_SUBSCRIPTION]: WHATSAPP_CHANNEL
});
const CommunicationChannelToFilterFamily = Object.freeze({
  [SMS_CHANNEL]: SMS_SUBSCRIPTION,
  [WHATSAPP_CHANNEL]: WHATSAPP_SUBSCRIPTION
});
export const isCommunicationSubscriptionFilterFamily = filterFamily => {
  if (filterFamily in CommunicationFilterFamilyToChannelMap) {
    return true;
  }
  return false;
};
export const communicationFilterFamilyToChannel = filterFamily => {
  return CommunicationFilterFamilyToChannelMap[filterFamily];
};
export const communicationChannelToFilterFamily = channel => {
  return CommunicationChannelToFilterFamily[channel];
};
export const isCommunicationSubscriptionFilter = filter => {
  if (filter.filterType === COMMUNICATION_SUBSCRIPTION) {
    return true;
  }
  return false;
};